module.exports = __webpack_public_path__ + "static/img/14000154.23ca57d1.png";